import React, { useContext } from 'react';
import { RootContext } from '../context';

import largeIcons from '../../assets/skillwheel/icons-skillwheel-largeperks.png?as=webp';
import mediumIcons from '../../assets/skillwheel/icons-skillwheel-mediumperks.png?as=webp';
import smallIcons from '../../assets/skillwheel/icons-skillwheel-smallperks.png?as=webp';

// Importação das imagens de fundo para cada vocação
import backdropDruid from '../../assets/skillwheel/backdrop_skillwheel_front_druid.png?as=webp';
import backdropKnight from '../../assets/skillwheel/backdrop_skillwheel_front_knight.png?as=webp';
import backdropSorcerer from '../../assets/skillwheel/backdrop_skillwheel_front_sorc.png?as=webp';
import backdropMonk from '../../assets/skillwheel/backdrop_skillwheel_front_monk.png?as=webp';
import backdropPaladin from '../../assets/skillwheel/backdrop_skillwheel_front_paladin.png?as=webp';

import styles from './Wheel.module.css';
import data from '../../data.yaml';
import { cssVars } from '../utils';
import { WheelSlice } from './WheelSlice';
import { Widget } from './Widget';
import { WheelRevelation } from './WheelRevelation';
import { PromptTerminal } from './PromptTerminal';

const ROTATIONS = {
  knight: 90,
  paladin: -90,
  sorcerer: 180,
  druid: 0,
  monk: -180,
};

const BACKDROPS = {
  knight: backdropKnight,
  paladin: backdropPaladin,
  sorcerer: backdropSorcerer,
  druid: backdropDruid,
  monk: backdropMonk,
};

const CORNERS = new Array(4).fill(0).map((_, i) => i);
const SLICES = new Array(36).fill(0).map((_, i) => 35 - i);

export const Wheel = () => {
  const {
    vocation,
    pointsMax,
    pointsLeft,
    reset,
  } = useContext(RootContext);

  const currentVocation = vocation;
  const currentBackdrop = BACKDROPS[currentVocation];

  return (
    <section
      className={styles.wheel}
      style={cssVars({
        bgfront: `url(${currentBackdrop})`,
        rotation: `${ROTATIONS[currentVocation]}deg`,
      })}
    >
      <svg width="522" height="522" xmlns="http://www.w3.org/2000/svg" fill="transparent">
        <defs>
          {new Array(data.conviction.length).fill(0).map((_, i) => (
            <pattern
              key={`medium-${i}`}
              id={`medium-${i}`}
              patternUnits="userSpaceOnUse"
              width="30"
              height="30"
            >
              <image
                href={mediumIcons}
                x={i * -30}
                y="0"
                width={30 * data.conviction.length}
                height="30"
              />
            </pattern>
          ))}
          {new Array(data.dedication.length).fill(0).map((_, i) => (
            <pattern
              key={`small-${i}`}
              id={`small-${i}`}
              patternUnits="userSpaceOnUse"
              width="16"
              height="16"
            >
              <image
                href={smallIcons}
                x={i * -16}
                y="0"
                width={16 * data.dedication.length}
                height="16"
              />
            </pattern>
          ))}
          {new Array(data.revelation.length).fill(0).map((_, i) => (
            <pattern
              key={`large-${i}`}
              id={`large-${i}`}
              patternUnits="userSpaceOnUse"
              width="34"
              height="34"
            >
              <image
                href={largeIcons}
                x={i * -34}
                y="0"
                width={34 * data.revelation.length}
                height="34"
              />
            </pattern>
          ))}
        </defs>

        <g transform="translate(261,261)">
          {/* Note que a imagem de fundo dinâmica agora é aplicada via ::before */}
          <g transform={`rotate(${ROTATIONS[currentVocation]}deg)`}>
            {CORNERS.map((i) => (
              <WheelRevelation key={`corner-${i}`} index={i} />
            ))}
            {SLICES.map((i) => (
              <WheelSlice key={`slice-${i}`} index={i} />
            ))}
          </g>
        </g>
      </svg>

      <Widget>
        <PromptTerminal />
      </Widget>
      <Widget>
        <p>
          Used points: {pointsMax - pointsLeft}/{Math.max(0, pointsMax)}
          <button style={{ float: 'right' }} onClick={reset}>
            reset
          </button>
        </p>
        <details>
          <summary>Usage</summary>
          <p>
            The interface works like in the game - click to select a perk and use buttons to add or remove points.
            Right click on a slice to fill it completely; if it's already full or you have no points left it will be
            cleared instead.
          </p>
          <p>You can share your builds using the URL - it automatically updates on any change.</p>
        </details>
      </Widget>
    </section>
  );
};
